import { cn } from '../lib/cn';
import { SWATCH_FILL } from './status-styles';
import { MAP_STATUS_ORDER, type ArgentinaMapLabels, type MapStatus } from './types';

/** The statuses the consumer declared labels for, in canonical order. */
export function legendStatuses(labels: ArgentinaMapLabels): MapStatus[] {
  return MAP_STATUS_ORDER.filter((status) => labels.statuses[status] !== undefined);
}

export function MapLegend({
  labels,
  counts,
}: {
  labels: ArgentinaMapLabels;
  counts: Record<MapStatus, number>;
}) {
  return (
    <div>
      <p className="mb-3 text-[0.7rem] font-semibold uppercase tracking-[0.18em] text-ink-muted">
        {labels.legendTitle}
      </p>
      <ul className="space-y-2 text-sm">
        {legendStatuses(labels).map((status) => (
          <li key={status} className="flex items-center gap-3">
            <StatusSwatch status={status} />
            <span className="text-ink">{labels.statuses[status]?.label}</span>
            <span className="ml-auto font-mono text-xs text-ink-muted">{counts[status]}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}

/** compact variant (site Home): inline chips below the grid, no panel. */
export function MapCompactLegend({
  labels,
  counts,
}: {
  labels: ArgentinaMapLabels;
  counts: Record<MapStatus, number>;
}) {
  return (
    <ul className="flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-ink-muted">
      {legendStatuses(labels).map((status) => (
        <li key={status} className="inline-flex items-center gap-2">
          <StatusSwatch status={status} compact />
          <span>{labels.statuses[status]?.label}</span>
          <span className="font-mono text-ink-subtle">{counts[status]}</span>
        </li>
      ))}
    </ul>
  );
}

function StatusSwatch({ status, compact = false }: { status: MapStatus; compact?: boolean }) {
  return (
    <span
      aria-hidden="true"
      className={cn('inline-block border', compact ? 'h-2.5 w-2.5' : 'h-3 w-3', SWATCH_FILL[status])}
    />
  );
}
